import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetVamAssetsQuery,
  GetVamAssetsResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  shortErrorMessage?: string
  params?: GetVamAssetsQuery
  children?: (data: GetVamAssetsResponse) => ReactElement
  onSuccess?: (data: GetVamAssetsResponse) => void
  onError?: (error: Error) => void
}

const GetSuitesRequest = ({
  shortErrorMessage,
  params,
  children,
  onSuccess,
  onError
}: Props) => {
  const url = `${VAM_SERVICE}/assets`

  const { requestParams } = useGetParamsWithSpaceId<GetVamAssetsQuery|undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetSuitesRequest
